/** Forbidden 관련 */
const FORBIDDEN = {
  MOBILE_CONTENT: `Do not currently support mobile.\nPlease connect to your PC.`,
  WEB_CONTENT: `Kstadium bridge is optimized for Chrome browsers.\nPlease connect with a chrome browser.`,
};

export { FORBIDDEN };
